import { AuditModel } from "./auditModel";

export class Task extends AuditModel {
  public taskId: any = 0;
  public clientId: any = 0;
  public clientName: any = "";
  public jobCode: any = "";
  public jobName?: any = "";
  public contextId: any = 0;
  public type: any = "";
  public accountingFirmId: any=0;
  public taskTitle: any="";
  public description: any="";
  public dueDate: any;
  public startDate: any;
  public assignee: string="";
  public priority: string="";
  public status: string="";
  public contestId: any;
  public contestType: any="";
  public reminders: any="";
  public isBillable: boolean=false;
  public billableType: any="";
  public billableAmount: any;
  public assignUserIds: any;
  public assignees: string="";
  public assigneeCount: any;
  public date: any;
  public strtdate: any;
  public due_date: any;
  public difference: any;
  public days: any;
  public taskGroupId: any = 0;
  public taskType: any = 0;
  public templateId: number =0;
  public assigneeUserDetails?: any[] = [];
  public taskAssigneejson: string = "";
  public unit: number;
  public roleId: number = 0;
}

export class JobTask extends AuditModel {
  public taskId: any = 0;
  public accountingFirmId: any = 0;
  public taskTitle: any = "";
  public description: any = "";
  public dueDate: Date;
  public priority: string = "";
  public contestId: any;
  public contestType: any = "";
  public reminders: any = "";
  public isBillable: boolean = false;
  public billableType: any = "";
  public billableAmount: any;
}


export class UserTimesheet {
  public count: any = 0;
  public Isgroupby: any = 0;
  public userId: any = "";
  public task: any = "";
  public logTimeId: any = 0;
  public description: any = "";
  public duration: any = 0;
  public createdOn: Date;
  public staff: any = "";
  public isBillable: boolean = false;
  public cost: any = 0;
  public _lstComment: any;
}

export class UserTimesheetFilter {
  public userId: any = "";
  public staff: any = "";
  public createdOn: Date;
}

export class TaskGroupList {
  public TaskgroupId: number;
  public AccountingFirmId: number;
  public  Sequence: number;
  public TaskGroupName: string
  public CreatedBy: string
  public JobId:number;
}

export class JobTemplateModel extends AuditModel {
  public templateName: string;
  public templateId: any = 0;
  public jobTypeName: string;
  public description: string;
  public isDeactivate: any;
  public jobTypeId: any;
  public jobTemplateMode: string;
  public teamId:number;
  public templateEstimateType: 'Job' | 'Task';
}

export class TemplateTaskGroupList {
  public TaskgroupId: number;
  public AccountingFirmId: number;
  public Sequence: number;
  public TaskGroupName: string
  public CreatedBy: string
  public TemplateId: number;
}

export class TemplateTask {
  public taskId: number;
  public taskgroupId: number;
  public unit: number;
  public taskTypeId: number;
  public taskType: string;
  public taskName: string;
  public taskTitle: string;
  public templateId: number;
  public createdBy: any;
  public updated_At: any;
  public roleId: number;
  public taskInfoJson?: string;
  public taskCategory:number;
  public startAfterDays:number;
  public dueAfterDays:number;
}

export class TaskModel extends AuditModel {
  public TaskId: any = 0;
  public TaskName: string;
  public TaskType: string;
  public status: string;
  public taskProgress: any;
  public dueDate: any;
  public isExpanded: any = false;
  public subtasks: any = [];
}

export class Subtask {
  public TaskId: any = 0;
  public TaskName: string;
  public TaskType: string;
  public status: string;
  public taskProgress: any;
  public dueDate: any;
  public statusOnhold: any = false;
}

export class TasksDetail {
  public taskIds: any;
  public dueDate: any;
  public contextFlag: any;
  public contextUser: string;
  public due_date: any;
}

export class Notes extends AuditModel{
  public ContextId: number;
  public Notes: string;
  public NotesDesc: string;
  public visibility: string;
  public visibiltyFlag: string
  public noteId: any = 0;
  public ContextType: string;
  public assignee: string;
  public pinNote: boolean;
  public Comment: string;
  public TaggedUsers: string;
  public Created_At: string;
}

export class TaskSetting extends AuditModel {
  filter(arg0: (x: any) => boolean): any {
      throw new Error("Method not implemented.");
  }
  public taskId: any=0;
  public accountingFirmId: any = 0;
  public entityTypeId: any = "";
  public taskTypeId: any = "";
  public jobTypeId: any = "";
  public taskTitle: any="";
  public description: any = "";
  public taskType: any;
  public assignee: string="";
  public isBillable: boolean=false;
  public billableType: any = "";
  public billMethod: any = "";
  public billableAmount: any;
}

export class TaskReplyModel extends AuditModel {
  public TaskReplyID: any=0;
  public TaskID: any=0;
  public ClientID: any="";
  public UserID: any = "";
  public UserName: string;
  public ReplyToID: any=0;
  public ReplyToName: string="";
  public Message: any;
  public TaggedUsers: any;
}

export class Wipdat {
  value: any;
  startDate: any;
  createdDate: any;
  jobid: any;
}

export class TaxAgent extends AuditModel {
  public Name: string;
  public TaxAgentNumber: string;
  public ABN: string;
  public TaxAgentType: string;
  public Contacts: TaxContact[] = [];
}

export class TaxContact {
  public UserId : string;
}


export class Tag extends AuditModel {
  public tagId: number
  public accountingFirmId: number
  public tagName: any
  public catogery: any
  public colour: any
}
